import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(public)/buy/[slug]/error.tsx");
